import { useNavigate, useSearchParams } from "react-router-dom";

import AdminRoutes from "Routes/Components/Admin";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Section from "Components/Admin/Section";

import SeletivaForm from "../Components/SeletivaForm";
import * as S from "./styles";

const CreateSeletiva = () => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sponsorIdParam = searchParams.get("sponsor_id");

  // Ao chegar no contexto de um patrocinador (?sponsor_id), voltamos ao detalhe
  // dele após concluir ou cancelar; caso contrário, à listagem de seletivas.
  const returnPath = sponsorIdParam
    ? AdminRoutes.DetailSponsor.path.replace(":id", sponsorIdParam)
    : AdminRoutes.ListSeletivas.path;

  const submit = (payload) => {
    setLoading(true);

    api
      .post("/select-projects/create", payload)
      .then(() => {
        setLoading(false);
        showNotification("success", "Sucesso!", "Seletiva criada com sucesso!");
        navigate(returnPath);
      })
      .catch((error) => {
        setLoading(false);
        return HTTPErrorCallback(error);
      });
  };

  return (
    <Section>
      <S.Wrapper>
        <SeletivaForm
          defaultSponsorId={sponsorIdParam}
          onSubmit={submit}
          onCancel={() => navigate(returnPath)}
          submitLabel={loading ? "Salvando..." : "Criar Seletiva"}
          loading={loading}
        />
      </S.Wrapper>
    </Section>
  );
};

export default CreateSeletiva;
